export default __webpack_public_path__ + "static/media/06_krmelec-min.52a378fc.jpg";